import React from "react";
import "./Stack.css";

import { useTranslations } from "../../i18n";
import wordpress from "../../Images/stack/wordpress.svg";
import bricks from "../../Images/stack/bricks.svg";
import strapi from "../../Images/stack/strapi.svg";
import nextjs from "../../Images/stack/nextjs.svg";
import nestjs from "../../Images/stack/nestjs.svg";
import n8n from "../../Images/stack/n8n.svg";
import gsap from "../../Images/stack/gsap.svg";
import postgres from "../../Images/stack/postgres.svg";
import mysql from "../../Images/stack/mysql.svg";
import supabase from "../../Images/stack/supabase.svg";
import github from "../../Images/stack/github.svg";
import claude from "../../Images/stack/claude.svg";

// `color` is the official brand colour, revealed on hover. Left off for brands
// that are intentionally monochrome (Next.js, GitHub) or shown as wordmarks.
const dev = [
  { name: "WordPress", icon: wordpress, color: "#21759B" },
  { name: "Bricks Builder", icon: bricks, color: "#EF5D3B" },
  { name: "Strapi", icon: strapi, color: "#4945FF" },
  { name: "Next.js", icon: nextjs },
  { name: "NestJS", icon: nestjs, color: "#E0234E" },
  { name: "n8n", icon: n8n, color: "#EA4B71" },
  { name: "GSAP", icon: gsap, color: "#0AE448" },
  { name: "Motion.dev", mark: "M", color: "#FFDC00" },
  { name: "PostgreSQL", icon: postgres, color: "#4169E1" },
  { name: "MySQL", icon: mysql, color: "#00758F" },
  { name: "Supabase", icon: supabase, color: "#3FCF8E" },
  { name: "GitHub", icon: github },
];

const ai = [
  { name: "Claude Code", icon: claude, color: "#D97757" },
  { name: "Kimi Code", mark: "K", color: "#6C5CE7" },
  { name: "Open Router", mark: "OR", color: "#6467F2" },
];

const Tile = ({ item }) => (
  <div className="stack-item" style={{ "--brand": item.color }}>
    <div className="stack-mark">
      {item.icon ? (
        <span
          className="stack-icon"
          style={{
            maskImage: `url(${item.icon})`,
            WebkitMaskImage: `url(${item.icon})`,
          }}
          aria-hidden="true"
        />
      ) : (
        <span className="stack-initials" aria-hidden="true">
          {item.mark}
        </span>
      )}
    </div>
    <p>{item.name}</p>
  </div>
);

const Stack = () => {
  const t = useTranslations();
  return (
    <section className="stack">
      <div className="stack-container">
        <div className="stack-label">
          <p>{t.stack.label}</p>
        </div>

        <div className="stack-group">
          <div className="stack-group-label">
            <p>{t.stack.development}</p>
          </div>
          <div className="stack-grid">
            {dev.map((item) => (
              <Tile key={item.name} item={item} />
            ))}
          </div>
        </div>

        <div className="stack-group">
          <div className="stack-group-label">
            <p>{t.stack.ai}</p>
          </div>
          <div className="stack-grid">
            {ai.map((item) => (
              <Tile key={item.name} item={item} />
            ))}
            <div className="stack-item stack-item-empty" aria-hidden="true"></div>
          </div>
          <div className="stack-note">
            <p>{t.stack.note}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stack;
